export const ScrollOptions = {
  DELTA: 3,
};
